import axios from 'axios'
import { baseUrl } from 'api/config'

export interface AuditTrailUser {
  id: string
  email: string
}

export interface AuditTrailEvent {
  id: string
  user: AuditTrailUser
  action: number
  reason: string | null
  date_created: string
  ip_address: string | null
}

export const fetchAuditTrail = async (contractId: string): Promise<AuditTrailEvent[] | null> => {
  const panda_access_token = localStorage.getItem('panda_access_token')
  if (!panda_access_token) {
    console.log('No Panda Access Token Found')
    return null
  }
  try {
    const response = await axios.get(
      `${baseUrl}/aws/pandadoc/documents/${contractId}/audit-trail`,
      {
        headers: {
          Authorization: `Bearer ${panda_access_token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data?.results ?? response.data ?? []
  } catch (error) {
    console.error('Error fetching audit trail:', error)
    return null
  }
}
